<template>
  <div>
    <PageTitle
      title="Document Uploads"
      :btnCreate="true"
      :createRoute="'/document-uploads/add'"
      :permission="'Document Upload Create'"
    />
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <TableFilters
            :filters="['status', 'dateRange', 'search']"
            v-model="filter"
            :columns="columns"
            paginationOptions
            :msgs="'Name'"
          ></TableFilters>
        </v-card>
      </v-expand-transition>
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <ValidationObserver ref="observer">
            <form>
              <v-row v-if="messages.length != 0">
                <v-col>
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <template>
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            outlined
                            type="error"
                            >{{ msg }}</v-alert
                          >
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-card-text class="pa-0">
                  <v-data-table
                    :items-per-page="paginationOptions.perPage"
                    :headers="headers"
                    :items="DocumentUploadList"
                    item-key="id"
                    class="row-pointer document-txt"
                    hide-default-footer
                  >
                    <template v-slot:no-data>
                      <div class="mt-10 container justify-center item-center">
                        <noData name="document upload" />
                      </div>
                    </template>
                    <template v-slot:item.name="{ item }">
                      <CopyTableCell :text="item.name"></CopyTableCell>
                    </template>
                    <template
                      v-slot:item.date="{ item }"
                      v-slot="{ errors }"
                      name="value"
                      rules="numeric"
                      >{{
                        item.date ? item.date : '---------' | formatDate
                      }}</template
                    >
                    <template
                      v-slot:item.name="{ item }"
                      v-slot="{ errors }"
                      name=" Name"
                      >{{ item.name ? item.name : '---------' }}</template
                    >
                    <template
                      v-slot:item.description="{ item }"
                      v-slot="{ errors }"
                      name="Description"
                      >{{
                        item.description ? item.description : '---------'
                      }}</template
                    >

                    <!-- Status -->
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :x-small="true"
                        class="ma-2"
                        label
                        text-color="white"
                        :color="getStatusColor(item.is_active)"
                        dark
                        >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                      >
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <list-menu
                        feature="document-uploads"
                        :item="item"
                        viewPermission="Document Upload Show"
                        editPermission="Document Upload Edit"
                        softDeletePermission="Document Upload Soft Delete"
                        @refreshList="refreshData"
                      ></list-menu>
                    </template>
                    <template v-slot:footer>
                      <paginationComponent
                        @paginationOptions="setPaginationOptions"
                        @response="receiveDocumentUploadData"
                        @getPageNumber="setPagenumber"
                        :filterAction="true"
                        url="document-uploads"
                        :filter="filter"
                        ref="pagination"
                      />
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-row>
            </form>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { numeric } from 'vee-validate/dist/rules';
import noData from '../../../components/shared/noItem';
import TableFilters from '@/components/base/TableFilters';

import _ from 'lodash';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import paginationComponent from '../../shared/components/pagination.vue';
import axios from '@/plugins/axios';

import * as moment from 'moment/moment';

extend('numeric', {
  ...numeric,
  message: 'input must be numeric',
});
export default {
  data: () => ({
    show: false,
    paginationOptions: {},
    messages: [],
    errors: [],
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Date',
        value: 'date',
        show: true,
        align: 'left',
        disabled: true,
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        align: 'left',
        disabled: true,
      },

      {
        text: 'Description',
        value: 'description',
        show: true,
        align: 'left',
        disabled: false,
      },

      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Actions',
        value: 'actions',
        show: true,
        disabled: true,
        align: 'center',
      },
    ],
    // For Document Upload Table Data
    DocumentUploadList: [],

    //For Filter
    date_range: [],
    filter: {
      start: '',
      end: '',
      search: '',
      status: '',
    },
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    noData,
    TableFilters,
  },
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    getStatusColor(is_active) {
      return is_active ? 'green' : 'gray';
    },

    clearFilter() {
      this.filter = {};
      this.date_range = [];
    },
    receiveDocumentUploadData(data) {
      this.DocumentUploadList = data;
    },
    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    archiveDocumentUpload(documentUpload) {},
    addDocumentUpload() {
      this.$router.push(`document-uploads/add`);
    },
    GetDocumentUploads({}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`document-uploads`)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.document-txt {
  font-family: 'Source Sans Pro', sans-serif;
}
.min-button::before {
  display: none;
}
</style>
